export const withOrdinal = (n: number) => {
  // get last 2 digits of rank
  const lastTwoDigits = n % 100;
  const lastDigit = lastTwoDigits % 10;

  switch (true) {
    case lastTwoDigits === 11:
    case lastTwoDigits === 12:
    case lastTwoDigits === 13:
      return n + 'th';
    case lastDigit === 1:
      return n + 'st';
    case lastDigit === 2:
      return n + 'nd';
    case lastDigit === 3:
      return n + 'rd';
    default:
      return n + 'th';
  }
};
